var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGlobalProvide6 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "global-provide-6_svg__a",
  width: 33,
  height: 32,
  x: 3,
  y: 5,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M36 5.185H4V36h32z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#408BFC",
  strokeWidth: 2,
  mask: "url(#global-provide-6_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 34.815c7.856 0 14.223-6.368 14.223-14.222 0-7.855-6.367-14.223-14.222-14.223S5.779 12.738 5.779 20.593c0 7.854 6.367 14.222 14.222 14.222Z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M19.487 11.111v9.91c0 .474.53.756.923.491l6.524-4.386"
}))));
export default SvgGlobalProvide6;